export default "__VITE_ASSET__5751b8ba__"